import { render } from "./placeholders.vue?vue&type=template&id=041559bb"
import script from "./placeholders.vue?vue&type=script&lang=js"
export * from "./placeholders.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__